import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import user from "./modules/user";
import offers from "./modules/offers";
import offer from "./modules/offer";
import create from "./modules/create";
import loader from "./modules/loader";
import permissions from "./modules/permissions";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: { auth, user, offers, offer, create, loader, permissions },
});

export default store;
